const About = () => {
  const services = [
    { icon: 'fa-chart-line', title: 'Advanced Analytics & Modelling' },
    { icon: 'fa-magnifying-glass', title: 'Secondary & Primary Research' },
    { icon: 'fa-microscope', title: 'Patent & Scientific Literature' },
    { icon: 'fa-briefcase', title: 'Investment Research & Analytics' },
    { icon: 'fa-table-columns', title: 'Custom Dashboards' },
    { icon: 'fa-screwdriver-wrench', title: 'Decision Tools' },
  ]

  return (
    <section 
      id="about" 
      className="py-24 bg-white relative overflow-hidden scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <h2 className="text-sm font-bold tracking-widest text-blue-600 uppercase mb-3">
              About The Simple
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Who We Are
            </h3>
            <div className="h-1 w-20 bg-black mb-8"></div>
            <p className="text-lg text-gray-600">
              Backed by Fortune 500 senior CXOs, we are committed to transforming complexity into
              clarity and intelligence into impact.
            </p>
          </div>

          <div className="prose prose-lg text-gray-600 space-y-6">
            <p className="text-xl font-medium text-gray-900">
              The Simple is a <span className="text-blue-600">next-generation intelligence firm</span>{' '}
              built at the intersection of advanced analytics, curated research, financial and
              quantitative modelling.
            </p>
            <p>
              We exist to simplify the complex and automate the simple. At the core of our delivery
              is a team of specialists who combine practical business insight with emerging
              technologies to deliver high-impact, decision-ready intelligence.
            </p>
            <p>
              Our team brings an average of over 10 years of experience, blending technical mastery
              with strategic clarity. We are researchers, data scientists, former operators, and
              advisors.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-black mt-6">
              <p className="italic font-medium text-gray-800 m-0">
                "Our mission is to provide proactive intelligence that empowers our clients to
                achieve their business goals."
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20">
          <h3 className="text-2xl font-bold mb-8 text-center">What We Do</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((service, idx) => (
              <div
                key={idx}
                className="p-6 bg-white border-2 border-gray-300 rounded-xl shadow-md hover:shadow-lg hover:border-gray-400 hover:bg-gray-50 transition-all"
              >
                <div className="w-10 h-10 bg-black text-white rounded-lg flex items-center justify-center mb-4">
                  <i className={`fa-solid ${service.icon}`}></i>
                </div>
                <h4 className="font-bold text-lg text-gray-900">{service.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
